<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title"><span><i>Raw Material</i></span></p>
<p class="fm-01"><i>This is a book about two families</i>—<i>a blacksmith’s and an upholsterer’s. It tells by the wayside a little of what made the author</i>—<i>who has a certain standing in his own volume of so-called Raw Material. It is also a trip to Jerusalem (as the Nottingham pub is called), a personal statement, a voyage to the battlefields of France, a dip-book, a family-album, a hundred-year time-span, a mirror through which the author not only brings his people into the open but comes out with them as well</i>—<i>holding their hands, as it were, while they speak</i>.</p>
<p class="fm-02">Raw Material <i>is anything but raw like the meat in a butcher’s shop, though there are characters in it who bleed in various places. It is neither quite fiction nor non-fiction, but a mish-mash of fact, and an artefact of fiction, a conscious romp in a half-disciplined style, a self-portrait of a non-man, a non-portrait of a self-made man, a first-rate port of call for the affections and afflictions that come to mind</i>—<i>which are offered on a bookplate for all to read and, if possible, relish</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?0d94de5e